import { GROUP_MODE_ENABLED } from '../../shared/messages'

export default function Instructions() {
  return (
    <div className="space-y-4 font-body text-sm text-warmblack/80 leading-relaxed">
      <div>
        <p className="font-bold text-warmblack mb-1">The idea</p>
        <p>
          One player (the <b>ranker</b>) secretly ranks 5 random items from
          favorite to least favorite, then draws a line separating the ones
          they like from the ones they don't. Everyone else tries to guess
          their ranking.
        </p>
      </div>
      <div>
        <p className="font-bold text-warmblack mb-1">Filling the bowl</p>
        <p>
          In the lobby, everyone adds items — foods, movies, hot takes,
          anything. Stuck? Tap "Need ideas?" for suggestions. Once there are
          at least 5 items and 3 players, the host can start the game.
        </p>
      </div>
      <div>
        <p className="font-bold text-warmblack mb-1">A round</p>
        <ol className="list-decimal list-inside space-y-1.5">
          <li>5 items are drawn from the bowl.</li>
          <li>Everyone discusses the items briefly.</li>
          <li>The ranker secretly orders them and places <b>the line</b>.</li>
          <li>
            {GROUP_MODE_ENABLED ? (
              <>
                In <b>group mode</b>, the scribe enters the group's consensus
                guess. In <b>individual mode</b>, every non-ranker submits
                their own guess.
              </>
            ) : (
              <>Every non-ranker submits their own guess.</>
            )}
          </li>
          <li>The ranker reveals items one at a time, then the line.</li>
        </ol>
      </div>
      <div>
        <p className="font-bold text-warmblack mb-1">Scoring</p>
        <p>
          For each item in your guess, compared to the ranker's actual order:
        </p>
        <ul className="list-disc list-inside space-y-1 mt-1">
          <li><b>+1</b> if the item is on the same side of the line.</li>
          <li><b>+2</b> if the item is at the exact same position.</li>
        </ul>
        <p className="mt-1">
          These stack — an exact match scores 1 + 2 = 3 points. Max per round
          is 5 × 3 = 15 points. The ranker doesn't score for their own round.
          Everyone goes as ranker once before anyone repeats.
        </p>
      </div>
      <div>
        <p className="font-bold text-warmblack mb-1">After the round</p>
        <p>
          Anyone can advance to "See How Everyone Did". Long-press a revealed
          item to react with an emoji. The host decides when to start the
          next round. The bowl persists between games — only the host can
          clear it.
        </p>
      </div>
    </div>
  )
}
